import React from "react";
import { Edit, useForm, useSelect } from "@refinedev/antd";
import { Form, Input, Switch, Select, Card } from "antd";
import type { IProduct, IUpdateProduct } from "../../interfaces/product";

export const ProductEdit: React.FC = () => {
    const { formProps, saveButtonProps, queryResult } = useForm<IProduct, any, IUpdateProduct>({
        resource: "Product",
        redirect: "list",
    });

    const { selectProps: taxSelectProps } = useSelect({
        resource: "taxes",
        optionLabel: "taxType",
        optionValue: "id",
        defaultValue: queryResult?.data?.data?.taxId,
    });

    return (
        <Edit saveButtonProps={saveButtonProps}>
            <Form {...formProps} layout="vertical">
                <Form.Item name="id" hidden>
                    <Input />
                </Form.Item>

                <Card title="Basic Information">
                    <Form.Item
                        label="Item Code"
                        name="itemCode"
                    >
                        <Input disabled />
                    </Form.Item>

                    <Form.Item
                        label="Product Name"
                        name="itemName"
                        rules={[{ required: true }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Description/Type"
                        name="itemTypeCode"
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="HS Code/Classification"
                        name="itemClassificationCode"
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Barcode"
                        name="barcode"
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Additional Information"
                        name="additionalInformation"
                    >
                        <Input.TextArea rows={3} />
                    </Form.Item>

                    <Form.Item
                        label="Tax"
                        name="taxId"
                    >
                        <Select {...taxSelectProps} />
                    </Form.Item>

                    <Form.Item
                        label="Active"
                        name="isActive"
                        valuePropName="checked"
                    >
                        <Switch />
                    </Form.Item>
                </Card>
            </Form>
        </Edit>
    );
};

export default ProductEdit;
